
exports.REQ_POST = "POST"
exports.REQ_GET = "GET"

exports.SAMART_AI_SERVICE_URL = "https://smartaistreams8.beta-wspbx.com/"

exports.APP_NAME = "smartai"

exports.REQ_LOGIN = "re_api/authenticate_user/";
exports.REQ_CSRF_TOKEN = "re_api/get_csrf_token/"

//==============        OpenAI Chatbot  Requests    ====================
exports.REQ_INIT_BOT_THREAD = "chatbot/init_bot_thread/"
exports.REQ_ASK_QUESTION = "chatbot/ask_question/"

//==============        Connect Summary Requests    ====================
exports.REQ_CONNECT_SUMMARY = "connect/connect_summary/";